<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ChuangZuoWeiXuanZhong`]" width="1em" height="1em" v-bind="$attrs"><rect x="2.092" y="2.093" width="19.815" height="19.815" rx="3" stroke="#929293" stroke-width="2"/><path d="M16.291 10.9365H13.0574V7.70288C13.0574 7.10781 12.5745 6.625 11.9795 6.625C11.3844 6.625 10.9016 7.10781 10.9016 7.70288V10.9365H7.66797C7.0729 10.9365 6.59009 11.4193 6.59009 12.0144C6.59009 12.6095 7.0729 13.0923 7.66797 13.0923H10.9016V16.3259C10.9016 16.921 11.3844 17.4038 11.9795 17.4038C12.5745 17.4038 13.0574 16.921 13.0574 16.3259V13.0923H16.291C16.8861 13.0923 17.3689 12.6095 17.3689 12.0144C17.3689 11.4193 16.8861 10.9365 16.291 10.9365Z" :fill="useCurrentColor ? 'currentColor' : '#929293'"/></svg>
</template>
<script>

export default {
  name: 'IconChuangZuoWeiXuanZhong',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
